// Shared bits for the in-house e-signature screens (TKT-401).

export const ESIGN_STATUSES = ['sent', 'viewed', 'completed', 'declined', 'voided', 'expired'];

export const ACTIVE_ESIGN_STATUSES = ['sent', 'viewed'];

export const esignStatusColor = (status) => {
  switch (status) {
    case 'completed':
      return 'success';
    case 'sent':
    case 'viewed':
      return 'info';
    case 'declined':
      return 'error';
    case 'voided':
    case 'expired':
      return 'default';
    default:
      return 'default';
  }
};

export const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export const formatDateTime = (value, language) => {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString(String(language || '').startsWith('es') ? 'es-MX' : 'en-CA', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
};

// Read an error message from a failed API response.
export const apiError = async (res, fallback) => {
  try {
    const data = await res.json();
    return data.error || fallback;
  } catch {
    return fallback;
  }
};
